var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.133,
    height: 28.626
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#fff",
    strokeWidth: 3,
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.133)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 10.5,
    r: 10.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 10.5,
    r: 9
  })), /*#__PURE__*/React.createElement("path", {
    d: "M11.633 17.5L2.12 26.506",
    strokeLinecap: "round"
  }))));
}
export default SvgSearch;